@if (isLoading()) {
  <div style="display:flex;align-items:center;justify-content:center;height:100%;color:#999">
    Loading chat...
  </div>
}

<div #chatContainer class="chat-mount"></div>
